/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import Kpi from "../../components/KPI/Kpi";


function DetailsDesktop({ app, config }) {
	const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });
  const { selections } = useSelections();
  const [selectedValue, setSelectedValue] = useState("Vendedores");

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Apuracao")
        : null;
      setSelectedValue(distributors?.qSelected);

    }
  }, [app, selections]);

  const handleChange = (event) => {
    app.field("Apuracao").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

	const selectedQuarter = Kpi({
		app,
		objectId: "jzfBCy",
	});

	return (
		<div className="app details">
			<div className="appContent">
      <Grid container rowGap={2} flexDirection={"column"} gap={"16px"}>
        <Grid item paddingBottom={"0px"} >
          <LayoutWrapper>
            <Card
              app={app}
              exportTable
              exportContainer
              exportTableId="QkkpGU"
              header={{
                hardTitle: "Apuração",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue={selectedValue}
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Vendedores"
                    sx={{
                      color: "#212121",
                    }}
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#E36025",
                          "&.Mui-checked": {
                            color: "#E36025",
                          },
                        }}
                      />
                    }
                    label="Vendedores"
                  />

                  <FormControlLabel
                    value="Supervisores"
                    sx={{
                      color: "#212121",
                    }}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#E36025",
                          "&.Mui-checked": {
                            color: "#E36025",
                          },
                        }}
                      />
                    }
                    label="Supervisores"
                  />
                </RadioGroup>
              </FormControl>
              <NativeObject
                app={app}
                key="QkkpGU"
                reference={{ id: "QkkpGU" }}
                style={{ height: '525px' }}
              />

            </Card>
          </LayoutWrapper>

        </Grid>

        <Grid item>
          <LayoutWrapper>
            <Card
              app={app}
              exportTable
              exportContainer
              exportTableId="DjdbL"
              header={{
                hardTitle: "Apuração por CNPJ",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <NativeObject
                app={app}
                key="DjdbL"
                reference={{ id: "DjdbL" }}
                style={{ height: '525px' }}
              />

            </Card>

          </LayoutWrapper>

        </Grid>

      </Grid>
			</div>
		</div>
	);
}

DetailsDesktop.defaultProps = {
	app: null,
	config: {},
};

DetailsDesktop.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default DetailsDesktop;
